// Bump PACK_VIDEO_VERSION after re-running scripts/make_pack_videos.py so browsers fetch the new copies.
export const PACK_VIDEO_VERSION = "20260601a";

export const packVideo = (sectorId) => ({
  mp4: `/videos/packs/${sectorId}.mp4?v=${PACK_VIDEO_VERSION}`,
  poster: `/videos/packs/${sectorId}-poster.jpg?v=${PACK_VIDEO_VERSION}`,
});

const KEY_TO_SECTOR = { cqc: "cqc", ofsted: "ofsted", aesthetics: "aesthetics", healthcare: "healthcare", fostering: "fostering" };

export const sectorForLookupKey = (lookupKey) => {
  const m = /^([a-z]+)_(policy_pack|full_policy_package)$/.exec(lookupKey || "");
  return m ? KEY_TO_SECTOR[m[1]] || null : null;
};
